import { memo, useEffect, useState } from 'react'
import LazyLoad from 'react-lazyload'

import Ad from '@/components/Ad/Ad'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { useAds } from '@/contexts/ads'
import { tcgLandUrl } from '@/utils/constants'
import getRandomAd from '@/utils/getRandomAd'

import styles from './Leaderboard.module.scss'

type Props = {
  country?: string
}

const Leaderboard = ({ country }: Props) => {
  const { loadAds } = useAds()
  const [randomRoll, setRandomRoll] = useState<number>(0)

  // Reroll ad every minute
  useEffect(() => {
    setRandomRoll(Math.random())
    const interval = setInterval(() => {
      setRandomRoll(Math.random())
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  if (loadAds === false) return null

  /* Ad Setup:
     - (no outside ads atm)

     - Half of remainder split between SCM
     - Other half of remainder goes to EDHREC Patreon
  */
  const ad =
    randomRoll === 0 ? null : randomRoll < 0.0 + 1.0 * (1 / 14) ? (
      <Ad id='archidekt' />
    ) : randomRoll < 0.0 + 1.0 * (2 / 14) ? (
      <Ad id='cs' />
    ) : randomRoll < 0.0 + 1.0 * (3 / 14) ? (
      <Ad id='csb' />
    ) : randomRoll < 0.0 + 1.0 * (4 / 14) ? (
      <Ad id='edhrecap' />
    ) : randomRoll < 0.0 + 1.0 * (5 / 14) ? (
      <Ad id='edhrecast' />
    ) : randomRoll < 0.0 + 1.0 * (6 / 14) ? (
      <Ad id='fabrec' />
    ) : randomRoll < 0.0 + 1.0 * (6.25 / 14) ? (
      <Ad id='spellifyDark1' />
    ) : randomRoll < 0.0 + 1.0 * (6.5 / 14) ? (
      <Ad id='spellifyDark2' />
    ) : randomRoll < 0.0 + 1.0 * (6.75 / 14) ? (
      <Ad id='spellifyLight1' />
    ) : randomRoll < 0.0 + 1.0 * (7 / 14) ? (
      <Ad id='spellifyLight2' />
    ) : randomRoll < 0.0 + 1.0 * (7 / 14 + 1 / 6) ? (
      <Ad id='edhrecPatreon' />
    ) : randomRoll < 0.0 + 1.0 * (7 / 14 + 2 / 6) ? (
      <Ad id='edhrecPatreon201' />
    ) : (
      <Ad id='edhrecPatreon202' />
    )

  if (loadAds === undefined) return <div className={styles.container} />

  if (country === 'MX') {
    const randomAd = getRandomAd('tcg.land/desktop')
    return (
      <div className={styles.inhouse}>
        <OutboundLink url={tcgLandUrl} utm_medium='leaderboard'>
          <img alt='TCG.Land' className={styles.tcgland} src={randomAd.src} />
        </OutboundLink>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.leaderboard}>
        <LazyLoad>{ad}</LazyLoad>
      </div>
    </div>
  )
}

export default memo(Leaderboard)
